import React, {useState} from 'react';
import {Modal} from 'react-bootstrap';

import styles from './Success.module.scss';
import {Button} from 'src/components/common/button/Button';

import classNames from 'classnames';
import IconSuccess from 'src/components/icons/IconSuccess';

export const SuccessModal = ({show,title,children,onClose}) => {

    return (<Modal
        show={show}
        onHide={() => onClose()}
        animated="false"
        className="modal fade in theme-light"
        dialogClassName="modal-sm"
        backdropClassName="in"
    >
        <div className="modal-header no-border">
            <Button className="close" onClick={() => onClose()}>
                <i className="icon-close-thin"/>
            </Button>
        </div>
        <div className={styles.modal_body}>
            <IconSuccess className={classNames(styles.icon, 'text-success')}/>
            <div className={styles.content}>
                <p className={styles.title}>{title}</p>
                {children !== null && <div>{children}</div>}
            </div>
        </div>
    </Modal>);
};

